module.exports = __webpack_public_path__ + "static/media/Hurtig.69587586.m4a";